import React, { Component } from 'react';
import BackButton from '../lib/BackButton';
import '../../scss/QuestionDetail.scss';

import Moment from 'react-moment';

export default class QuestionDetail extends Component {
  
  render() {
    let { router: {
      location: { state },
      match: { params: { question } }
    }, questions} = this.props;

    let previousPath = state && state.previous || '/';
    let { title, yes, no, questionText, stories } = questions.find(q => q.slug === question);
  
    
    return (
      <div className="QuestionDetail">
        <BackButton path={previousPath} />
        
        <h2 className="QuestionDetail__header">
          {questionText}
        </h2>
        
        <div className="QuestionDetail__body">
          <div className="QuestionDetail__item">
            <h3 className="QuestionDetail__title">Yes</h3>
            
            <p className="QuestionDetail__position">
              {yes}
            </p>
          </div>
          
          <div className="QuestionDetail__item">
            <h3 className="QuestionDetail__title">No</h3>
            
            <p className="QuestionDetail__position">
              {no}
            </p>
          </div>
        </div>
        
        <div className="QuestionDetail__footer">
          {stories &&
            <div className="QuestionDetail__stories">
              <h3 className="QuestionDetail__header">More on this Question</h3>
              {stories.map((story, i) => {
                return (
                  <div key={i} className="QuestionDetail__story">
                    <h4 className="QuestionDetail__story-title">{story.description}</h4>
                    (<a href={story.link} target="_blank">{story.credit}, <Moment parse="MM/D" date={story.date} format="MMMM D" /></a>)
                  </div>
                );
              })}
            </div>
          }
          <BackButton pill={true} path={previousPath} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/QuestionDetail.js